<template>
  <v-card
    class="ma-0 mb-4 mt-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 py-1"
    >
      <v-btn
        class="ms-2 mt-4"
        outlined
        color="teal"
        small
        @click="addRow()"
      >
        {{ $t('addNewInvestor') }}
        <v-icon
          color="teal"
          class="ms-3"
          style="font-size: 22px"
        >
          mdi-plus
        </v-icon>
      </v-btn>
      <v-spacer />
    </v-app-bar>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row class="mx-0 my-2" />
      <v-col
        cols="12"
        class="px-2 py-0 "
      >
        <v-data-table
          v-if="headers"
          v-model="selected"
          :height="tableHeight"
          fixed-header
          :headers="headers"
          :items="items"
          :options.sync="tableOptions"
          :server-items-length="totalItems"
          :loading="loading"
          multi-sort
          dense
          :show-select="showSelect"
          hide-default-footer
          item-key="id"
        >
          <template v-slot:item.actions="{ item }">
            <v-menu
              offset-y
            >
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  v-bind="attrs"
                  icon
                  v-on="on"
                >
                  <v-icon
                    medium
                  >
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  link
                  @click="openDeleteDialog(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="pink">
                      mdi-trash-can-outline
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('remove')" />
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:item.row="{ item }">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </template>
          <template v-slot:item.account="{ item }">
            <autocomplete
              v-model="item.account"
              :rules="[v => !!v || $t('is-required')]"
              :title="$t('investor')"
              :value="item.account"
              type="person"
              :new-btn="true"
              @input="changeInvestor(item)"
              :data="JSON.stringify({type: 'investor'})"
            />
          </template>
          <template v-slot:item.percent="{ item }">
            <v-text-field
              v-model="item.percent"
              :label="$t('investorPercent')"
              height="20"
              dense
              :rules="[v => !!v || $t('is-required')]"
              outlined
              type="number"
              clearable
            />
          </template>
        </v-data-table>
      </v-col>
      <v-divider class="mx-2" />
      <v-card-actions class="pt-0" />
      <v-row />
    </v-form>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import General from '../../../../../Mixins/general'
  export default {
    name: 'SellList',
    components: {
    },
    mixins: [General],
    props: ['input', 'formType', 'value', 'costs', 'method'],
    data: () => ({
      selected: [],
      printDialog: false,
      deletDialog: false,
      showSelect: false,
      render: false,
      filter: false,
      valid: true,
      detail: null,
      snakbarColor: 'blue',
      recipientEntrepot: null,
      relations: null,
      productStatus: null,
      productStatusItems: null,
      date: null,
      entrepot: null,
      model: null,
      from: 1,
      taskDialog: null,
      id: null,
      status: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 1000,
      isLoading: false,
      snakbar: false,
      typeForm: null,
      type: 'receipt',
      taskId: null,
      snakbarText: null,
      loading: true,
      tableOptions: {
        itemsPerPage: 1000,
      },
      headers: null,
      search: null,
    }),
    watch: {
      value () {
      },
      items: {
        handler: function (val, oldVal) {
          this.$emit('input', this.items)
        },
        deep: true,
      },
      refId (val, oldVal) {
      // this.items = []
      // this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      tableOptions: {
        handler () {
          var app = this
          app.sortBy = []
          app.tableOptions.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      relations () {
        var app = this
        if (app.relations && app.relations.article) {
          app.items = []
          app.items = app.relations.article
        } else {
          app.addRow()
        }
      },
    },
    beforeMount () {
      this.type = this.$route.name
      if (this.$route.params.id != null) {
        this.render = false
        this.id = this.$route.params.id
      } else {
        this.render = true
        this.addRow()
      }
    },
    mounted () {
      if (this.value) {
        this.items = this.value
      }
      this.headers = [
        {
          text: '#',
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 40,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 40,
        },
        {
          text: this.$t('account'),
          sortable: false,
          value: 'account',
        },
        {
          text: this.$t('percent'),
          sortable: false,
          value: 'percent',
        },
      ]
      this.typeItems = [
        {
          value: 'price',
          text: this.$t('sellPrice'),
        },
        {
          value: 'discount',
          text: this.$t('discount'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.loading = false
    },
    methods: {
      changeInvestor (item) {
        // if (!item.value) {
        //   if (item.investor) {
        //     item.percent = item.investor.investorSellPercent
        //   } else {
        //     item.percent = null
        //   }
        // }
      },
      addRow () {
        this.items.push({
          account: null,
          percent: null,
        })
      },
      remove (item, index1) {
        var index = this.items.indexOf(item)
        this.items.splice(index, 1)
        this.deletDialog = false
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
    },
  }
</script>

<style scoped>

</style>
